import { ubiquAxios } from "@/main";
import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useChartStore = defineStore("chart", () => {
  const lastEvents = ref<Date[]>([]);
  const currentProviderUuid = ref<string | null>(null);
  const currentProviderName = ref<string | null>(null);

  const fetchLastEvents = async () => {
    if (!currentProviderUuid.value) {
      console.warn("No provider selected, skipping fetch.");
      return;
    }
    try {
      const response = await ubiquAxios.get(
        `/rse_provider/${currentProviderUuid.value}/rse/`,
      );
      lastEvents.value = response.data.map(
        (event: { last_event: string }) => new Date(event.last_event),
      );
    } catch (error) {
      console.error("Error fetching last event: ", error);
      lastEvents.value = [];
    }
  }

  const setProvider = (providerUuid: string) => {
    currentProviderUuid.value = providerUuid;

    if (!currentProviderUuid.value) {
      console.warn("Provider UUID not found for the given provider name.");
    }
  }

  const getChartData = computed(() => {
    if (!lastEvents.value.length) return { labels: [], values: [] };

    const sortedDates = [...lastEvents.value].sort((a, b) => a.getTime() - b.getTime());
    const monthCounts: Record<string, number> = {};
    sortedDates.forEach((date) => {
      const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
      monthCounts[key] = (monthCounts[key] || 0) + 1;
    });

    const firstDate = sortedDates[0];
    const lastDate = sortedDates[sortedDates.length - 1];
    const labels: string[] = [];
    const values: number[] = [];

    let currentDate = new Date(firstDate.getFullYear(), firstDate.getMonth(), 1);
    const endDate = new Date(lastDate.getFullYear(), lastDate.getMonth(), 1);

    while (currentDate <= endDate) {
      const key = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}`;
      labels.push(key);
      values.push(monthCounts[key] || 0);
      currentDate.setMonth(currentDate.getMonth() + 1);
    }

    return { labels, values };
  });

  return {
    lastEvents,
    currentProviderUuid,
    currentProviderName,
    fetchLastEvents,
    setProvider,
    getChartData,
  };
}, { persist: true });
